import React from 'react';

import { Button } from '@/components/button';
import { Heading } from '@/components/heading';
import { Text } from '@/components/text';
import { tv } from '@/utils/styles';

export interface SearchMessageProps {
  heading?: string;
  body?: string;
  image?: string;
  buttonText?: string;
  onClick?: () => void;
  className?: string;
}

export const SearchMessage = ({
  heading,
  body,
  image = 'search-prompt',
  buttonText = '',
  onClick,
  className,
}: SearchMessageProps) => {
  const { content, imageContainer } = styles();
  return (
    <div className={content({ className })}>
      {Boolean(image) && (
        <div className={imageContainer()} style={{ backgroundImage: `url("/assets/${image}.png")` }} />
      )}
      {Boolean(heading) && (
        <Heading variant="h4" as="h1" className="m-base">
          {heading}
        </Heading>
      )}
      {Boolean(body) && (
        <Text variant="secondary" className="leading-normal text-grey-600">
          {body}
        </Text>
      )}
      {buttonText && <Button onClick={onClick}>{buttonText}</Button>}
    </div>
  );
};

const styles = tv({
  slots: {
    content: 'max-w-[440px] text-center',
    imageContainer: 'mb-8 ml-auto mr-auto w-full max-w-[428px] bg-contain bg-center bg-no-repeat pb-[38%]',
  },
});
